'use client'

import type { ReactNode } from 'react'
import { PanelsSurfaceProvider, type PanelsSkin, type PanelsSurface } from '@/deskUiSkeletons/Page/PanelsSurfaceContext'
import { MoreLink } from '@/deskUiSkeletons/Shared/Shared'
import { mainTemplateVariant, menuTemplateVariant } from '../rowTemplates/RowTemplateConfig'
import { PortalCheckedsInfo, PortalFoldSubsButton, PortalPagingBar, PortalRefreshSubs } from './PortalControls'

const portalPanelsSkin: PanelsSkin = {
  toolbar: 'hidden',
  toolbarHide: 'hidden',
  toolbarMessage: 'hidden',
  panelAnswers: 'relative mx-auto mb-8 flex max-w-4xl flex-col rounded-2xl border border-slate-200 bg-white p-4 shadow-sm',
  panelSubmsges: 'relative mx-auto mb-8 flex max-w-4xl flex-col rounded-2xl border border-slate-200 bg-white p-4 shadow-sm',
  panelTools: 'mb-3 flex min-h-8 flex-wrap items-center gap-2',
  rootList: 'flex list-none flex-col gap-2 p-0 text-sm',
  sectionInfo: 'mb-3 inline-flex w-max items-center rounded-full bg-blue-100 px-3 py-1.5 text-xs font-semibold text-blue-800',
  sectionInfoCount: 'ml-1',
  menuPanel: 'hidden',
  menuPanelShown: 'hidden',
  menuPanelHidden: 'hidden',
  togglePhoto: 'hidden',
  menuPanelTools: 'hidden',
  menuList: 'hidden',
  sectionSwitch: 'hidden',
  sectionSwitchButton: 'hidden',
  sectionSwitchButtonActive: 'hidden',
  sectionSwitchButtonInactive: 'hidden',
  menuEmpty: 'px-2 py-4 text-xs text-slate-400',
}

const portalPanelsSurface: PanelsSurface = {
  FoldSubsButton: PortalFoldSubsButton,
  PagingBar: PortalPagingBar,
  RefreshSubs: PortalRefreshSubs,
  CheckedsInfo: PortalCheckedsInfo,
  MoreLink,
  menuEmptyLabel: 'Not found',
  config: { mainTemplateVariant, menuTemplateVariant },
  skin: portalPanelsSkin,
}

export function PortalPanelsSurfaceProvider({ children }: { children: ReactNode }) {
  return <PanelsSurfaceProvider value={portalPanelsSurface}>{children}</PanelsSurfaceProvider>
}
